import React from 'react';
import { cn } from '../lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from './Card';

/**
 * Metronic DataCard - For displaying data tables and lists
 * Perfect for activities, candidates, jobs lists
 *
 * @param {string} title - Card title
 * @param {React.ReactNode} children - Table or list content
 * @param {React.ReactNode} actions - Optional header actions (buttons, filters)
 * @param {boolean} loading - Loading state
 * @param {string} emptyMessage - Message when no data
 * @param {string} className - Additional classes
 */
const DataCard = ({
  title,
  children,
  actions,
  loading = false,
  emptyMessage = 'No data available',
  className
}) => {
  return (
    <Card className={cn("h-full", className)}>
      {title && (
        <CardHeader className="flex-row items-center justify-between">
          <CardTitle>{title}</CardTitle>
          {actions && (
            <div className="flex items-center gap-2">
              {actions}
            </div>
          )}
        </CardHeader>
      )}
      <CardContent className="p-0">
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="flex flex-col items-center gap-3">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              <p className="text-sm text-muted-foreground">Loading...</p>
            </div>
          </div>
        ) : children ? (
          children
        ) : (
          <div className="flex items-center justify-center py-12">
            <p className="text-sm text-muted-foreground">{emptyMessage}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

/**
 * DataCardHeader - Simple action button for DataCard
 */
export const DataCardAction = ({ children, onClick, variant = 'outline' }) => {
  const variants = {
    primary: 'text-primary hover:text-primary/80',
    outline: 'text-muted-foreground hover:text-foreground',
  };

  return (
    <button
      onClick={onClick}
      className={cn(
        "text-sm font-medium transition-colors",
        variants[variant]
      )}
    >
      {children}
    </button>
  );
};

export default DataCard;

